// new ESDFileSelector({allowedFileTypes: ['.sdIconPack','.streamdeckIconPack' ],includeObjectUrl: false})
import Utils from './utils.js';

export class ESDFileSelectorXX {
    constructor (inOptions = {}) {
        // this.debug = inOptions && inOptions.debug;
        this.debug = false;
        const tag = inOptions.name || 'ESDFileSelectorXX';
        const clr = Utils && Utils.colorFromString(tag) || 'ccee00';
        this.dbg = this.debug ? console.log.bind(window.console, `%c[${tag}] `, `color: #${clr}`) : () => {};

        this.options = {};
        this.initOptions(inOptions);

    }
    
    getFolders(entry) {
         const flatten = (array) => array.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
        return this.traverseDirectory(entry, true).then(fileEntries => {
             return flatten(fileEntries);
        })
    }
    getFolderContents(entry) {
        const folderPromises = [];
        const filePromises = [];
        const dataTransferFiles = [];
        folderPromises.push(this.traverseDirectory(entry, false));
        if(folderPromises.length) {
            const flatten = (array) => array.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);
            return Promise.all(folderPromises).then((fileEntries) => {
                console.log("folderPromises", fileEntries);
                const flattenedEntries = flatten(fileEntries);
                // collect async promises to convert each fileEntry into a File object (this is an async process)
                flattenedEntries.forEach((fileEntry) => {
                    fileEntry.hello = Date.now();
                    filePromises.push(this.getFile(fileEntry));
                });
                return this.handleFilePromises(filePromises, dataTransferFiles);
            });
        } else if(filePromises.length) {
            return this.handleFilePromises(filePromises, dataTransferFiles);
        }
    }

    traverseDirectory(entry, bFolderMode = false, options) {
        entry && this.dbg("traverseDirectory", entry.name);
        if(options) this.initOptions(options);
        const self = this;

        const reader = entry.createReader();
        // Resolved when the entire directory is traversed
        return new Promise((resolveDirectory) => {
            const iterationAttempts = [];
            const errorHandler = () => {};
            function readEntries() {
                // According to the FileSystem API spec, readEntries() must be called until
                // it calls the callback with an empty array.
                // Chrome returns the entries in 100 entry-batches!!!
                reader.readEntries((batchEntries) => {
                    if(!batchEntries.length) {
                        // Done iterating this particular directory
                        resolveDirectory(Promise.all(iterationAttempts));
                    } else {
                        // Add a list of promises for each directory entry.  If the entry is itself
                        // a directory, then that promise won't resolve until it is fully traversed.
                        let filteredEntries;

                        if(bFolderMode) {

                            filteredEntries = batchEntries.filter(e => e.isDirectory);

                            iterationAttempts.push(
                                Promise.all(
                                    filteredEntries.map((batchEntry) => {
                                        if(!self.isValidFile(batchEntry, bFolderMode)) {
                                            return self.traverseDirectory(batchEntry, bFolderMode);
                                        }
                                        return Promise.resolve(batchEntry);
                                    })
                                )
                            );
                        } else {
                            filteredEntries = batchEntries.filter((e) => self.isValidFile(e, false));
                            iterationAttempts.push(
                                Promise.all(
                                    filteredEntries.map((batchEntry) => {
                                        if(batchEntry.isDirectory) {
                                            return self.traverseDirectory(batchEntry, false);
                                        }
                                        return Promise.resolve(batchEntry);
                                    })
                                )
                            );
                        }

                        // Try calling readEntries() again for the same dir, according to spec
                        readEntries();
                    }
                }, errorHandler);
            }
            // initial call to recursive entry reader function
            readEntries();
        });
    }

    packageFile(file, entry) {
        let fileTypeOverride = '';
        // handle some browsers sometimes missing mime types for dropped files
        const hasExtension = file.name && file.name.lastIndexOf('.') !== -1;
        if(hasExtension && !file.type) {
            const fileExtension = (file.name || '').split('.').pop();
            // fileTypeOverride = EXTENSION_TO_MIME_TYPE_MAP[fileExtension];
            fileTypeOverride = this.options.mappedMimeTypes[fileExtension];
        }

        return {
            // uuid: Utils.uuid(file.lastModified),
            // fileUrl: URL.createObjectURL(file),
            // new URL(URL.createObjectURL(new Blob(['']))).origin
            objectURL: this.options.includeObjectUrl ? URL.createObjectURL(file) : null,
            uid: `${file.name}-${file.lastModified}-${file.size}`,
            file,
            fullPath: entry ? this.copyString(entry.fullPath) : file.name,
            name: file.name,
            size: file.size,
            type: file.type ? file.type : fileTypeOverride

        };
    }

    getFile(entry) {

        if(entry.isDirectory) {
            return new Promise((resolve) => {
                const x = this.packageFile(entry, entry);
                console.log('getFile:folder:', entry, x);
                // resolve(this.packageFile(entry, entry));
                resolve(entry);
            });
        }

        return new Promise((resolve) => {
            entry.file((file) => {
                resolve(this.packageFile(file, entry));
            });
        });
    }

    handleFilePromises(promises, arrFiles) {
        return Promise.all(promises).then((files) => {
            return this.addFilesToArray(files, arrFiles);
        });
    }

    addFilesToArray(files, arrFiles) {
        files.forEach((file) => {
            if(!this.shouldIgnoreFile(file)) {
                arrFiles.push(file);
            }
        });
        return arrFiles;
    }

    getDataTransferFiles(dataTransfer, bFolderMode = false) {
        // this.initOptions();
        const dataTransferFiles = [];
        const folderPromises = [];
        const filePromises = [];

        [].slice.call(dataTransfer.items).forEach((listItem) => {
            // this.dbg("->getDataTransferFiles", listItem, (typeof listItem.webkitGetAsEntry === 'function'));
            if(typeof listItem.webkitGetAsEntry === 'function') {
                const entry = listItem.webkitGetAsEntry();
                if(entry) {
                    if(entry.isDirectory) {
                        if(this.isValidFile(entry, bFolderMode)) {
                            folderPromises.push(entry);
                        } else {
                            folderPromises.push(this.traverseDirectory(entry, bFolderMode));
                        }
                    } else {
                        if(this.isValidFile(entry, bFolderMode)) {
                            filePromises.push(this.getFile(entry));
                        }
                    }
                }
            } else {
                dataTransferFiles.push(listItem);
            }
        });
        if(folderPromises.length) {

            const flatten = (array) => array.reduce((a, b) => a.concat(Array.isArray(b) ? flatten(b) : b), []);

            return Promise.all(folderPromises).then((fileEntries) => {
                const flattenedEntries = flatten(fileEntries);
                // collect async promises to convert each fileEntry into a File object
                flattenedEntries.forEach((fileEntry) => {
                    filePromises.push(this.getFile(fileEntry));
                });
                // return this.handleFilePromises(filePromises, dataTransferFiles);
                const hfp = this.handleFilePromises(filePromises, dataTransferFiles);
                // console.log("FOLDERPROMISES:", hfp);
                return hfp;
            });
        } else if(filePromises.length) {
            const hfp = this.handleFilePromises(filePromises, dataTransferFiles);
            // console.log("FILEPROMISES:", hfp);
            return hfp;
        }
        return Promise.resolve(dataTransferFiles, folderPromises);
    }
    // isValidFile(file, checkDirectoryNames) {
    isValidFile(file) {
        // eslint-disable-next-line
        // console.log("isValidFile", file, checkDirectoryNames);
        // return true;
        /* eslint-disable-next-line */
        if(!file.isDirectory) {
            // return !/^(\.)/gi.test(file.name);
            this.rxStart.lastIndex = 0;
            return !this.rxStart.test(file.name);
       } 
        return true; //2021 test
        // if(file.isDirectory && !checkDirectoryNames) return true;
        // this.rxStart.lastIndex = 0; // const isValid = !/^__|^\./.test( file.name );
        // if(this.rxStart.test(file.name)) {
        //     this.rxValid.lastIndex = 0;
        //     return this.rxValid.test(file.name);
        // }
        // return false; //return isValid && new RegExp( `(${ Object.values( arr ).join( '|' ) })$`, 'gi' ).test( file.name );
    }

    shouldIgnoreFile(file) {
        return this.options.ignoredFilenames.includes(file.name);
    }

    // Utils
    copyString(aString) {
        return `${aString}`.slice(1);
    }
    initOptions(inOptions = {}) {
        const defaultOptions = {
            allowAll: false,
            allowedFileTypes: [
                '.sdIconPack',
                '.streamdeckIconPack'
            ],
            allowedFileTypesB: [
                '.png',
                '.jpg',
                '.svg',
                '.tif',
                '.tiff',
            ],
            ignoredFilenames: [
                '.DS_Store', // macOS Finder settings
                'Thumbs.db' // Windows Explorer settings
            ],
            ignoreFilesStartingWith: [
                '__', '\\.'
            ],
            includeObjectUrl: false,
            mappedMimeTypes: {
                avi: 'video/avi',
                tiff: 'image/tiff',
                gif: 'image/gif',
                ico: 'image/x-icon',
                jpeg: 'image/jpeg',
                jpg: 'image/jpeg',
                mkv: 'video/x-matroska',
                mov: 'video/quicktime',
                mp4: 'video/mp4',
                pdf: 'application/pdf',
                png: 'image/png',
                zip: 'application/zip'
            }
        };
        // console.log("+++++++++++++++++", this);
        this.options = Object.assign({}, defaultOptions, inOptions);
        this.dbg("options", this.options, this.options.includeObjectUrl);

        this.rxStartsWith = (arr) => new RegExp(`^(${Object.values(arr).join('*|')})`, 'gi');
        this.rxEndsWith = (arr) => new RegExp(`(${Object.values(arr).join('|')})$`, 'gi');
        this.rxValid = this.rxEndsWith(this.options.allowedFileTypes);
        this.rxStart = this.rxStartsWith(this.options.ignoreFilesStartingWith);
        if(this.options.includeObjectUrl) {
            // if file-system-access
            // this.options.includeObjectUrl = new URL(URL.createObjectURL(new Blob(['']))).origin === 'null';

            this.dbg("CHECK OBJECTURL", new URL(URL.createObjectURL(new Blob(['']))).origin === 'null');
        }
    }
    getDroppedOrSelectedFiles(event, bFolderMode = false) {
        if(event.dataTransfer && event.dataTransfer.items) {
            return this.getDataTransferFiles(event.dataTransfer, bFolderMode).then((fileList) => {
                return Promise.resolve(fileList);
            });
        }
        const files = [];
        const dragDropFileList = event.dataTransfer && event.dataTransfer.files;
        const inputFieldFileList = event.target && event.target.files;
        const fileList = dragDropFileList || inputFieldFileList || [];
        // convert the FileList to a simple array of File objects
        for(let i = 0;i < fileList.length;i++) {
            if(!this.shouldIgnoreFile(fileList[i])) {
                files.push(this.packageFile(fileList[i]));
            }
        }
        return Promise.resolve(files);
    }

}



/**
 * This function should be called from both the onDrop event from your drag/drop
 * dropzone as well as from the HTML5 file selector input field onChange event
 * handler.  Pass the event object from the triggered event into this function.
 * Supports mix of files and folders dropped via drag/drop.
 *
 * Returns: an array of File objects, that includes all files within folders
 *   and subfolders of the dropped/selected items.
 */
// eslint-disable-next-line
// getDroppedOrSelectedFiles(event, bFolderMode = false) {
//     if(event.dataTransfer && event.dataTransfer.items) {
//         return this.getDataTransferFiles(event.dataTransfer, bFolderMode).then((fileList) => {
//             return Promise.resolve(fileList);
//         });
//     }
//     const files = [];
//     const dragDropFileList = event.dataTransfer && event.dataTransfer.files;
//     const inputFieldFileList = event.target && event.target.files;
//     const fileList = dragDropFileList || inputFieldFileList || [];
//     // convert the FileList to a simple array of File objects
//     for(let i = 0;i < fileList.length;i++) {
//         if(!this.shouldIgnoreFile(fileList[i])) {
//             files.push(this.packageFile(fileList[i]));
//         }
//     }
//     return Promise.resolve(files);
// }

/*

let iconVerifyTimer = null;

verifyIconPack = (ip, startIndex = 0) => {
    if(ip && ip.icons) {
        let i = startIndex || 0;
        if(i < ip.icons.length) {
            if(iconVerifyTimer) iconVerifyTimer = null;
            const l = ip.icons.length;
            while(i < l && ip.icons[i].checked == true) {
                i++;
            }
            iconVerifyTimer = setTimeout(() => {
                verifyIcon(ip.icons[i], i);
                verifyIcons(i + 1);
                i++;
            }, 10);
        }
    }
};

verifyIcon = (icn, i) => {
    if(icn) {
        if(icn.file && !icn.thumbnailUrl) {
            icn.thumbnailUrl = URL.createObjectURL(icn.file);
        }
        icn._status['name'] = icn.name != "" ? 'isOK' : 'isError';

        if(icn.thumbnailUrl) {
            Utils.loadImageData(icn.thumbnailUrl, (img) => {
                icn.imageinfo = `w:${img.naturalWidth} h:${img.naturalHeight}`; // add icon info
                icn._status['imageinfo'] = (img.naturalWidth % MRequiredSizeFactor === 0) && (img.naturalHeight % MRequiredSizeFactor === 0);
                icn.checked = true;
                if((img.naturalWidth % MRequiredSizeFactor !== 0) || (img.naturalHeight % MRequiredSizeFactor !== 0)) {
                    icn.alt = 'To avoid scaling or blurred edges, image width or height should be a multiple of 36';
                    addStatus(icn, 'imageinfo', icn.alt);
                }
            });
        }
    }
};
addStatus = (icn, prop, value) => {
    if(!icn._status.hasOwnProperty('tips')) {icn._status.tips = {};};
    icn._status.tips[prop] = value;
};

*/

/*
iconPack = {
    manifest_json,  // containing an iconpacks meta information
    icon_svg,  // representative icon shown in the store and Image Library
    icons_json, // list of icons found in 'icons' folder
    icons,  // folder containing the icons  (*can* have subfolders),
    license_txt  // if provided
};

sdIconPack = {
    manifest = {
        "Name": "Name of icon pack",
        "Version": "1.0",
        "Author": "Famous Icon Creator",
        "URL": "https://www.elgato.com",
        "Icon": "icon.svg",
        "License": "license.txt"
    },

    icons =[
        {
            "path": "icon_1.svg",  // path starts at the top-level of the 'icons-folder
            "name": "Empty icon",
            "tags": []
        }
    ]

};

*/
